module.exports = __webpack_public_path__ + "static/media/amela.5e0fcc58.svg";